import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsProperties,
    defaultTicksCustomValue,
} from "../../../utils";

const PartActifsHabitants = {
    checked: false,
    titleSideBar: "Mobility Indicators Content.indicators.PartActifsHabitants",
    titleIndicator:
        "Mobility Indicators Content.indicators.PartActifsHabitants",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators]["partActifsHabitants"],
    },
    keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "250",
            widthChart: "600",
            i18nKeyLabels:
                "Mobility Indicators Content.charts.PartActifsHabitants.axis.labelsX",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: true,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    //stacked: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "Budget transport (%)",
                    gridDisplay: true,
                    beginAtZero: true,
                    // max: null,
                    max: 100,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: {
                    type: "linear",
                    display: false,
                    stacked: true,
                    titleDisplay: false,
                    titleText: "Mobility Indicators Content.charts.PartActifsHabitants.axis.titleY",
                    gridDisplay: false,
                    beginAtZero: true,
                    //max: 100,
                    ticks: {
                        display: false,
                        value: defaultTicksCustomValue,
                    },
                },
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "bar",
                    label: "Mobility Indicators Content.charts.PartActifsHabitants.legend.% Actifs",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=part_actifs_habitants&trend=projection&chart=part_actifs_habitants_pourcentage&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "0_opacity_part_actifs_habitants"
                        ].backgroundColor,
                    borderColor:
                        configChartsColorPalettes[
                            "0_opacity_part_actifs_habitants"
                        ].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "%",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "Mobility Indicators Content.charts.PartActifsHabitants.legend.Actifs",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=part_actifs_habitants&trend=projection&chart=part_actifs_habitants_actifs&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["transparent"]
                            .backgroundColor,
                    borderColor:
                        configChartsColorPalettes["transparent"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "yRight",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
                {
                    type: "bar",
                    label: "Mobility Indicators Content.charts.PartActifsHabitants.legend.Actifs - Reste de la population",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=part_actifs_habitants&trend=projection&chart=part_actifs_habitants_reste_population&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["transparent"]
                            .backgroundColor,
                    borderColor:
                        configChartsColorPalettes["transparent"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "yRight",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
            ],
        },
    ],
};

export default PartActifsHabitants;
